import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../src/common/SafeIcon';

const { FiCheckCircle, FiAward } = FiIcons;

export const Outcomes: React.FC = () => {
  const outcomes = [
    "Explain Bitcoin’s core value drivers in plain English",
    "Describe mining and energy economics without technical overload",
    "Put historical Bitcoin performance into responsible context",
    "Use portfolio-level frameworks to discuss risk & volatility",
    "Navigate firm restrictions and regulatory boundaries",
    "Handle “Should I buy Bitcoin?” conversations professionally"
  ];

  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-slate-900 rounded-3xl p-8 lg:p-12 shadow-2xl relative overflow-hidden">
          <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-600/20 rounded-full blur-[100px] pointer-events-none translate-x-1/3 -translate-y-1/3"></div>
          <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-accent-600/20 rounded-full blur-[100px] pointer-events-none -translate-x-1/3 translate-y-1/3"></div>
          <div className="relative z-10 grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 text-accent-400 font-semibold mb-4 bg-white/5 px-3 py-1 rounded-full w-fit backdrop-blur-sm border border-white/10">
                <SafeIcon icon={FiAward} className="w-4 h-4" />
                <span className="text-sm">Learning Outcomes</span>
              </div>
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-8 leading-tight">Walk away with a clear <br/> <span className="text-brand-400">Communication Framework</span></h2>
              <div className="space-y-6">
                {outcomes.map((outcome, idx) => (
                  <div key={idx} className="flex items-start gap-4 group">
                    <div className="mt-1 w-6 h-6 rounded-full bg-brand-900/50 border border-brand-500/50 flex items-center justify-center flex-shrink-0 group-hover:bg-brand-500 transition-colors">
                      <SafeIcon icon={FiCheckCircle} className="w-4 h-4 text-brand-400 group-hover:text-white transition-colors" />
                    </div>
                    <p className="text-slate-300 group-hover:text-white transition-colors text-lg font-light leading-relaxed">{outcome}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative hidden lg:block h-full min-h-[500px]">
              <div className="absolute inset-0 bg-slate-800 rounded-2xl rotate-2 opacity-50"></div>
              <div className="absolute inset-0 rounded-2xl overflow-hidden -rotate-2 border border-white/10 shadow-2xl">
                <img src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1000&q=80" alt="Advisor" className="w-full h-full object-cover opacity-90 hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 p-8 w-full">
                  <p className="text-white text-xl font-serif italic mb-2">"This framework changed how I speak to my HNW clients."</p>
                  <p className="text-brand-400 font-bold text-sm uppercase tracking-wider">RIA Partner, San Francisco</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};